export default "__VITE_ASSET__X$mlXBhh__"